import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import About from '@/components/About'
import Service from '@/components/Service'
import Web from '@/components/Web'
import Graphic from '@/components/Graphic'
import CIS from '@/components/CIS'
import SEO from '@/components/SEO'
import Social from '@/components/Social'
import Photographic from '@/components/Photographic'
import Process from '@/components/Process'
import Projects from '@/components/Projects'
import ProjectsDetail from '@/components/ProjectsDetail'
import Blog from '@/components/Blog'
import BlogDetail from '@/components/BlogDetail'
import Contact from '@/components/Contact'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/index.html',
      redirect: '/'
    },
    //首頁
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '無極限資訊行銷-首頁'
      }
    },
    //關於我們
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        title: '無極限資訊行銷-關於我們'
      }
    },
    //服務內容
    {
      path: '/service',
      name: 'Service',
      component: Service,
      redirect: '/service/web',
      meta: {
        title: '無極限資訊行銷-服務項目'
      },
      children: [{
          path: 'web',
          name: 'Service-web',
          component: Web,
          meta: {
            title: '無極限資訊行銷-服務項目-網頁設計'
          }
        },
        {
          path: 'graphic',
          name: 'Service-graphic',
          component: Graphic,
          meta: {
            title: '無極限資訊行銷-服務項目-平面設計'
          }
        },
        {
          path: 'cis',
          name: 'Service-cis',
          component: CIS,
          meta: {
            title: '無極限資訊行銷-服務項目-CIS設計'
          }
        },
        {
          path: 'seo',
          name: 'Service-seo',
          component: SEO,
          meta: {
            title: '無極限資訊行銷-服務項目-SEO整體規劃'
          }
        },
        {
          path: 'social',
          name: 'Service-social',
          component: Social,
          meta: {
            title: '無極限資訊行銷-服務項目-社群行銷'
          }
        }
      ]
    },
    //攝影/影像
    {
      path: '/photographic',
      name: 'Photographic',
      component: Photographic,
      meta: {
        title: '無極限資訊行銷-攝影/影像'
      }
    },
    {
      path: '/process',
      name: 'Process',
      component: Process,
      meta: {
        title: '無極限資訊行銷-服務流程'
      }
    },
    //作品專區
    {
      path: '/projects',
      name: 'Projects',
      component: Projects,
      meta: {
        title: '無極限資訊行銷-作品專區'
      }
    },
    //作品專區-內頁
    {
      path: '/projects/detail/:id',
      name: 'Projects-detail',
      component: ProjectsDetail,
      meta: {
        title: '無極限資訊行銷-作品專區'
      }
    },
    //BLOG
    {
      path: '/blog/page:pageNum',
      name: 'Blog',
      component: Blog,
      meta: {
        title: '無極限資訊行銷-BLOG'
      }
    },
    //BLOG-內頁
    {
      path: '/blog/detail/:id',
      name: 'Blog-detail',
      component: BlogDetail,
      meta: {
        title: '無極限資訊行銷-BLOG'
      }
    },
    //聯絡我們
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
        title: '無極限資訊行銷-聯絡我們'
      }
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title;
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js